import { useEffect } from "react";
import { useQuery } from "react-query";
import { useIntl } from "react-intl";
import useGlobalContext from "hooks/globalData";
import { AutocompleteWithQuery } from "@knowfully/ui.common";
import { AutocompleteWithQueryProps } from "@knowfully/ui.common/components/AutocompleteWithQuery";
import {
  AccessLevel,
  ListRequestOfBaseFilter,
} from "services/organizationPortalClient";
import contextStore from "stores/contextStore";

type SelectAccessLevelProps = Omit<
  AutocompleteWithQueryProps<AccessLevel>,
  "fetchedData" | "failMessage" | "labelField" | "multiple"
>;

export default function SelectAccessLevel(props: SelectAccessLevelProps) {
  const { formatMessage: t } = useIntl();
  const { organizationUserService } = useGlobalContext();
  const { organization } = contextStore.useState();

  const data = useQuery(
    ["organization-user-access-levels", organization?.id],
    () =>
      organizationUserService.getAccessLevels(
        ListRequestOfBaseFilter.fromJS({ sortField: "sequence" }),
      ),
  );

  const defaultValue = data.data?.data?.find((l) => l.sequence === 0)?.id || "";

  useEffect(() => {
    if (props.required && !props.value && defaultValue) {
      props.onChange(defaultValue);
    }
  }, [props.required, props.value, props.onChange, defaultValue, props]);

  return (
    <AutocompleteWithQuery
      {...props}
      size="small"
      labelField="displayName"
      disableClearable={props.required}
      fetchedData={data}
      label={t({ id: "levelOfAccess" })}
      failMessage={t({ id: "fetchError" })}
    />
  );
}
